import { createIcon } from "@chakra-ui/react";

export const StickyBottomBarAhPlusLogo = createIcon({
  displayName: "stickyBottomBarAhPlusLogo",
  viewBox: "0 0 23 24",
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3832 19.1084H2.6856C0.820771 19.1084 -0.471875 17.2767 0.163863 15.5698L5.165 2.22723C5.67359 0.895052 6.96624 0 8.40724 0C9.84825 0 11.1197 0.874241 11.6495 2.1856L16.8837 15.5282C17.5619 17.2558 16.2692 19.1084 14.3832 19.1084Z"
        fill="#0D73FF"
      />
      <path
        d="M14.3407 4.9124C13.811 4.9124 13.3024 5.03729 12.8574 5.24545L16.8837 15.5074C17.5618 17.235 16.2692 19.0876 14.3831 19.0876H6.60592L6.09735 20.4614C5.46161 22.1891 6.75426 24 8.61909 24H20.3167C22.2027 24 23.4954 22.1474 22.8173 20.4198L17.583 7.07719C17.0532 5.78665 15.7606 4.9124 14.3407 4.9124Z"
        fill="#FF6B73"
      />
      <path
        d="M12.8574 5.24545C12.0521 5.62012 11.4164 6.28617 11.0774 7.1396L6.60592 19.0876H14.3831C16.2692 19.0876 17.5618 17.235 16.8837 15.5074L12.8574 5.24545Z"
        fill="#0D3073"
      />
    </svg>
  ),
});
